export default __webpack_public_path__ + "static/media/logo_small.9f9a398b.svg";